import React, { useState } from "react";
import style from "./style.module.sass";
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { convertNumberToStringLocally } from "../../../../../utils";
import config from "../../../../../config"

export default function AccordionModalRectangleShaped({
    handleModalAccordionOpen,
    cells,
    windowsKey
}) {
    const [selectedCell, setSelectedCell] = useState(null)
    const { theme: { bgColors, colors } } = useTheme()
    const {
        t,
        i18n: { language: i18nLanguage },
    } = useTranslation();
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)    
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const modalAccordionOpen = useSelector(state => state.analyseData.modalAccordionOpen);
    const topAccordionOpen = useSelector(state => state.analyseData.topAccordionOpen)
    const tabIndex = windowsKey === topAccordionOpen ? '0' : '-1'     

    const handleClick = (id) => {
        setSelectedCell(cell => (cell === id ? null : id))
        handleModalAccordionOpen(modalAccordionOpen === id ? "" : id )
    }

    return (
        <ul className={`${style.mainCont}`}> 
            {cells.map(c => {
                return (
                    <p tabIndex={tabIndex} data-accordion-item={topAccordionOpen === windowsKey ? "accordion" : ""} data-compare-item={c.id} onClick={() => handleClick(c.id)} >
                        <li
                            key={c.id}
                            style={{ backgroundColor: isContrast ? bgColors.bgPrimary200 : bgColors.bgPrimary0, filter: isContrast ? 'none' : 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.12))' }}
                            className={`${style.recShapedRangerRow} ${style.open} ${selectedCell === c.id ? style.selected : ""}  p-2 pb-3 mb-2`}
                            >
                            <div className={style.modalWin}>
                                <div className={`d-flex justify-content-between`}>
                                    <p className={`m-0`} style={{ color: c.leftTextColor, fontSize: "18px", fontWeight: 700 }}>{t(c.leftText)}</p>
                                    <p className={`m-0`} style={{ color: c.rightTextColor, textDecoration: isContrast ? 'underline' : 'none', fontSize: "18px", fontWeight: 700 }}>{t(c.rightText)}</p>
                                </div>
                                <div className={style.rangeTrack} >
                                    {c.ranger.map(r => {
                                        const isActive = r === c.rangePosition
                                        return (
                                            <div
                                                key={r}
                                                className={`${style.rangeSegment} ${isActive ? style.rangeSegmentActive : ""}`}
                                                style={{ backgroundColor: c.colorRange ? c.colorRange : isContrast ? bgColors.bgPrimary0 : bgColors.bgPrimary200 }}
                                            >
                                                {isActive && (
                                                    <span className={style.rangeSegmentValue} style={{ color: colors.colorTextReverse, background: c.colorRangeBar }}>
                                                        {convertNumberToStringLocally(c.bottomNumber, i18nLanguage)}
                                                    </span>
                                                )}
                                            </div>
                                        )
                                    })}
                            <div className={style.rangeMidline} style={{ background: colors.colorPrimary200 }}/>
                        </div>
                    </div>
                </li>
            </p>
            )
            })}
        </ul>
    )
}
